module.exports = __webpack_public_path__ + "img/live1.7ca6b534.svg";